<div class="p-3">
    <div class='text-center'>
        <img src="assets/img/philippines.png" alt="Philippine History Timelines" class="d-inline-block align-top logo">
        <h1>Error 404</h1>
        <p>Page not found</p>
    </div>

    <div class='text-center'>
        <a class='btn btn-primary' routerLink="/">Return to Dashboard</a>
    </div>
</div>